import { IGeoConstraint } from '@faire/web-api--source/faire/geo/IGeoConstraint';
import { SettingConst } from '@faire/web-api--source/types';

/**
 * Empty docs
 */
export const BRAND_ADDITIONAL_SUPPORTED_GEOGRAPHIES =
  'BRAND_ADDITIONAL_SUPPORTED_GEOGRAPHIES' as SettingConst<
    'BRAND_ADDITIONAL_SUPPORTED_GEOGRAPHIES',
    Array<IGeoConstraint>,
    'RETAILER' | 'VISITOR_WEB'
  >;
